import { EpimsBaseEntityDto } from './epim-base.dto';
export class DamageAssessmentBreakDownDraftDto extends EpimsBaseEntityDto {
  
    
    DamageRefNo: string;
    CouponNo: string;
    Quantity: number;
    Rate: number;
    DamageId: string;
    ItemName: string;
    SpeculativeState: string;
    OTPApprovedRate: number;
    CompanyApprovedRate: number;
    FromSP: number;
    ToSP: number;
    Status: string;
    Total: number;
    SwathNo: string;
    SwathId: string;
    ProgrammeId: string;
    ProgrammeName: string;
    OMLId: string;
    DistanceCover: number;
    NewNegotiatedRate: number;
    ClaimantId: string;
    ClaimantName: string;
    CrewId: string;
    CrewName: string;
    AgreedNegotiatedRate: number;    
    SubscriptionUserId: string;  
    Version: number;
    Totals: number;

    LineTypeId: string;
    LineTypeName: string;
    LineNumber: string;
    OMLName: string;
    CountryId: string;
    CountryName: string;
    StateId: string;
    StateName: string;
    LGAId: string;
    LGAName: string;
    CommunityId: string;
    CommunityName: string;
}
